import { SearchInput } from '@/components/SearchInput';
import { videoFilters as _videoFilters } from '@/state/video-library/videoLibrary';
import { useRecoilState } from 'recoil';

export const Search = () => {
    const [videoFilters, setVideoFilters] = useRecoilState(_videoFilters);

    const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const value = e.currentTarget.value || '';
        setVideoFilters(filters => ({ ...filters, nameContains: value }));
    };

    const handleSearchClear = () => {
        setVideoFilters(filters => ({ ...filters, nameContains: '' }));
    };

    return (
        <SearchInput
            id="video-search-textfield"
            placeholder="Search videos"
            search={videoFilters.nameContains || ''}
            onChange={handleSearchChange}
            onClear={handleSearchClear}
        />
    );
};
